import React from "react";
import { Button, Tooltip } from "@mui/material";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedFilter } from "src/Redux/filterSlice/filterSlice";
import { setCurrentChartType } from "src/Redux/chartSlice/chartSlice";
import { setCurrentDateComparison } from "src/Redux/dateCompareSlice/dateCompareSlice";
import { setCurrentChartTypePerformance } from "src/Redux/brandPerformanceChartSlice/brandPerformanceChartSlice";
import { updateSalesType } from "src/Redux/twoColumnChartSlice/twoColumnChartSlice";
import { updateVolumeSalesType } from "src/Redux/twoColumnChartSlice/twoColumnChartVolumeSlice";
import { resetAllMarket } from "src/Redux/handleAllMarket/handleAllMarket";

const ResetFiltersButton = () => {
  const dispatch = useDispatch();

  // Read current filter-related state so we can avoid unnecessary resets
  const selectedFilter = useSelector((state) => state.filter.selectedFilter);
  const isAllMarketSelected = useSelector(
    (state) => state.allMarket.isAllMarketSelected
  );
  const currentChartType = useSelector((state) => state.chart.currentChartType);
  const currentDateComparison = useSelector(
    (state) => state.dateCompare.currentDateComparison
  );
  const currentChartTypePerformance = useSelector(
    (state) => state.brandPerformanceChart.currentChartTypePerformance
  );
  const currentSalesType = useSelector(
    (state) => state.twoColumnChart.currentSalesType
  );
  const currentVolumeSalesType = useSelector(
    (state) => state.twoColumnChartVolume.currentVolumeSalesType
  );

  const handleReset = () => {
    const isAlreadyDefault =
      (!selectedFilter || selectedFilter.length === 0) &&
      !isAllMarketSelected &&
      currentChartType == null &&
      currentDateComparison == null &&
      currentChartTypePerformance == null &&
      currentSalesType == null &&
      currentVolumeSalesType == null;

    // If nothing would actually change, do not reload or reset charts
    if (isAlreadyDefault) {
      return;
    }

    // Global/location filters
    dispatch(setSelectedFilter([]));
    dispatch(resetAllMarket());

    // Dashboard / chart-level filters
    dispatch(setCurrentChartType(null));
    dispatch(setCurrentChartTypePerformance(null));
    dispatch(setCurrentDateComparison(null));

    // Chart-specific Redux-managed filters
    dispatch(updateSalesType(null));
    dispatch(updateVolumeSalesType(null));

    // Notify all dashboard charts to reset their local UI state
    window.dispatchEvent(new Event("dashboardFiltersReset"));
  };

  return (
    <Tooltip title="Reset all dashboard filters to default">
      <span>
        <Button
          variant="outlined"
          startIcon={<RestartAltIcon />}
          onClick={handleReset}
          sx={{
            borderColor: "#08306B",
            color: "#08306B",
            fontWeight: "bold",
            textTransform: "none",
            borderRadius: "8px",
            backgroundColor: "#ffffff",
            "&:hover": {
              backgroundColor: "#f5f7fa",
              borderColor: "#08306B",
            },
          }}
        >
          Reset Filters
        </Button>
      </span>
    </Tooltip>
  );
};

export default ResetFiltersButton;

